import { createColumnHelper } from "@tanstack/react-table";

import { SOSEntityHashLink } from "@/components/SosEntityHashLink";
import {
  getCostTaxBreakdownColumnDefs,
  getCostTaxBreakdownSubtotalColumnDef,
} from "@/features/job-tracking/components/CostTaxBreakdownColumns";
import { LineItemDescription } from "@/features/job-tracking/components/LineItemDescription";
import { LineItemUOMQuantity } from "@/features/job-tracking/components/LineItemUOMQuantity";
import { EstimateTrackingInternalLink } from "../EstimateTrackingInternalLink";
import { TableLineItem } from "./estimate-details-table-data";

const columnHelper = createColumnHelper<TableLineItem>();

const lineDetailColumns = [
  columnHelper.accessor("lineNumber", { header: "#" }),
  columnHelper.accessor("item.name", {
    header: "Item",
    cell: ({ row }) => (
      <EstimateTrackingInternalLink trackerPath="bom-by-component">
        {({ targetPath, targetPageTitle }) => (
          <SOSEntityHashLink
            fromHash={row.id}
            urlPath={targetPath}
            tooltipContent={`View on '${targetPageTitle}' page`}
            type="item"
            id={row.original.item.id}
            label={row.original.item.name}
          />
        )}
      </EstimateTrackingInternalLink>
    ),
  }),
  columnHelper.accessor("description", {
    header: "Description",
    cell: ({ row }) => <LineItemDescription line={row.original} />,
  }),
  columnHelper.accessor("uomQuantity", {
    header: "Quantity",
    cell: ({ row }) => <LineItemUOMQuantity line={row.original} />,
  }),
];

const estimatedCostColumns = [
  getCostTaxBreakdownSubtotalColumnDef<TableLineItem>((row) => row.labour, "labour", {
    header: "Labour",
    useErrorPopover: true,
  }),
  getCostTaxBreakdownSubtotalColumnDef<TableLineItem>((row) => row.cogs, "cogs", {
    header: "COGS",
    useErrorPopover: true,
  }),
  ...getCostTaxBreakdownColumnDefs<TableLineItem>((row) => row.total, "total", { useErrorPopover: true }),
];

const quotedCostColumns = getCostTaxBreakdownColumnDefs<TableLineItem>((row) => row.quotedTotal, "quotedTotal");

export const estimateDetailsTableColumns = [
  columnHelper.group({ header: "Line Details", columns: lineDetailColumns }),
  columnHelper.group({ header: "Estimated Costs", columns: estimatedCostColumns }),
  columnHelper.group({ header: "Quoted Cost", columns: quotedCostColumns }),
];
